// Commission agencies sagas.
//
// Built on the shared watcher factories, so `take` is outside the try in every
// watcher and a failure can never kill one (see makeWatcher.es6.js).
//
//   - list and detail use the takeLatest equivalent, so a fast filter change
//     cannot land an out-of-order result
//   - the two writes use the plain watcher; neither moves money

import { put, select } from 'redux-saga/effects';
import * as types from '../../lib/actionTypes.es6';
import * as actions from './actions.es6';
import {
  makeWatcher,
  makeLatestWatcher
} from '../../components/CommissionsShared/makeWatcher.es6';
import {
  getCommissionAgencies,
  getCommissionAgency,
  createCommissionAgency,
  updateCommissionAgency
} from '../../lib/requests.es6';

// ─── Reads ───────────────────────────────────────────────────────────────────

export var getCommissionAgenciesRequestWatcher = makeLatestWatcher(
  types.GET_COMMISSION_AGENCIES_REQUEST,
  getCommissionAgencies,
  actions.getCommissionAgenciesSuccess,
  actions.getCommissionAgenciesFailed
);

export var getCommissionAgencyRequestWatcher = makeLatestWatcher(
  types.GET_COMMISSION_AGENCY_REQUEST,
  getCommissionAgency,
  actions.getCommissionAgencySuccess,
  actions.getCommissionAgencyFailed,
  // Accepts either a bare guid or { guid }.
  { args: function(payload) { return [payload && payload.guid ? payload.guid : payload]; } }
);

// ─── Writes ──────────────────────────────────────────────────────────────────

// After a write, refresh the list using the filters the user had applied rather
// than resetting them.
function* refreshAgencyList() {
  var params = yield select(function(state) {
    var slice = state.commissionAgencies;
    return (slice && slice.listParams) || {};
  });
  yield put(actions.getCommissionAgenciesRequest(params));
}

export var createCommissionAgencyRequestWatcher = makeWatcher(
  types.CREATE_COMMISSION_AGENCY_REQUEST,
  createCommissionAgency,
  actions.createCommissionAgencySuccess,
  actions.createCommissionAgencyFailed,
  { onSuccessEffects: refreshAgencyList }
);

export var updateCommissionAgencyRequestWatcher = makeWatcher(
  types.UPDATE_COMMISSION_AGENCY_REQUEST,
  updateCommissionAgency,
  actions.updateCommissionAgencySuccess,
  actions.updateCommissionAgencyFailed,
  {
    args: function(payload) { return [payload.guid, payload.body || payload]; },
    onSuccessEffects: refreshAgencyList
  }
);
